<template>
  <div class="personal_warp">
    <myHeader />
    <div class="personal_content">
      <div class="personal_title">
        <h3>MyOrder</h3>
      </div>
      <div class="personal_info">
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="name" label="Name" min-width="120" align="center">
          </el-table-column>
          <el-table-column  prop="phone"  label="Phone"  width="130"  align="center"  >
          </el-table-column>
          <el-table-column  prop="orderType"  label="Order Type" width="160"  align="center" >
            <template slot-scope="{row}">
              <span v-text="row.type == '1' ? 'Monthly Subscription' : row.type == '2' ? 'Annual Subscription' :'Daily Subscription' "></span>
            </template>
          </el-table-column>
          <el-table-column prop="subject" label="Product" align="center"  min-width="120">
          </el-table-column>
          <el-table-column   prop="time" label="Duration"   width="100" align="center"  ></el-table-column>
          <el-table-column  prop="rec_code" label="Referral Code"  width="120"  align="center" >
          </el-table-column>
          <el-table-column prop="price" label="Price" width="70" align="center">
          </el-table-column>
          <el-table-column   prop="pay_type"   label="Payment Method"  width="140"  align="center" >
          </el-table-column>
          <el-table-column   prop="pay_time"  label="Payment Time"  width="170" align="center" >
          </el-table-column>
          <el-table-column  prop="status_name"  label="Payment Status" width="130"  align="center" >
          </el-table-column>
          <el-table-column prop="operation"   label="Operation"  width="120"  align="center" fixed="right" >
            <template slot-scope="{row}">
              <!-- @click="handleEdit(scope.$index, scope.row)" -->
              <el-button size="small" type="text" v-if="row.is_invoice == 0" @click="issueInvoice(row)">Request Invoice</el-button>
              <span class="font12" v-if="row.is_invoice == 2">Processing</span>
              <span class="font12" v-if="row.is_invoice == 1">Issued</span>
              <!-- Request Invoice -->
              <!-- 开票处理中 Processing
               开票完成 Issued -->
            </template>
          </el-table-column>
        </el-table>
        <div class="table_pagination">
          <el-pagination
              background
              :current-page="pageNum"
              layout="prev, pager, next"
              :page-size="10"
              @current-change="handleCurrentChange"
              :total="total">
          </el-pagination>
        </div>
      </div>

    </div>
    <div
        v-if="showModal"
        class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Apply for Invoice</h3>
          <button class="close-btn" @click="showModal = false">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <p data-label="Bill To：">
            <select v-model="invoiceForm.billing_object" name="" id="billing_object"  @change="handleChangeBillingObject">
              <option :value="2">Individual</option>
              <option :value="1">Enterprise</option>
            </select>
          </p>
          <p data-label="Invoice Type：">
            <select v-model="invoiceForm.invoice_type" name="" id="invoice_type">
              <option :value="2">VAT Normal invoice</option>
              <option  v-if="invoiceForm.billing_object != 2" :disabled="invoiceForm.billing_object == 2" :value="1">VAT Special Invoice</option>
            </select>
          </p>

          <template v-if="invoiceForm.billing_object == 2">
            <p data-label="Name：">
              <input type="text" v-model="invoiceForm.name" />
            </p>
          </template>

          <template v-if="invoiceForm.billing_object == 1">
            <p data-label="Company Name：">
              <input type="text" v-model="invoiceForm.company_name" />
            </p>
            <p data-label="Tax ID：">
              <input type="text" v-model="invoiceForm.company_tax_id" />
            </p>
            <p data-label="Company Address：" >
              <input type="text" v-model="invoiceForm.company_address" placeholder="（Optional question）"/>
            </p>
            <p data-label="Phone Number：">
              <input type="text" v-model="invoiceForm.phone_number" placeholder="（Optional question）"/>
            </p>
            <p data-label="Bank Name：" >
              <input type="text" v-model="invoiceForm.bank_name" placeholder="（Optional question）"/>
            </p>
            <p data-label="Bank Account：">
              <input type="text" v-model="invoiceForm.bank_account" placeholder="（Optional question）"/>
            </p>
          </template>

          <p data-label="Email：">
            <input type="text" v-model="invoiceForm.email" />
          </p>
        </div>
        <div class="modal-footer">
          <el-button class="close-btn" @click="showModal = false">Cancel</el-button>
          <button class="confirm-btn" :disabled="btnDisabled" @click="confirmAuthorization">
            Confirm
          </button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import myHeader from "@/components/en_mobile/myHeader.vue";
import store from "@/store";
import {  invoiceAdd ,getIndexOrder} from "@/api/api";
export default {
  name: 'mobile_personalCenter',
  components: { myHeader, },
  data() {
    return {
      loading:false,
      btnDisabled:false,
      showModal: false,
      tableData: [   ],
      total:0,
      pageNum:1,
      invoiceForm:{
        billing_object:2,
        invoice_type:2,
        company_name:'',
        company_tax_id:'',
        email:'',
        name:'',
        company_address:'',
        phone_number:'',
        bank_name:'',
        bank_account:'',

      },
      invoiceInfo:null

    }
  },
  created() {
    this.getOrderList()
  },
  beforeMount() {

  },
  methods: {
    handleCurrentChange (val) {
      this.pageNum = val
      this.getOrderList()
    },
    getOrderList(){
      let postData = {
        page:this.pageNum,
        limit:10
      }
      this.loading = true
      getIndexOrder(postData).then(res =>{
        if(res.code == 200){
          let {list,count} = res.data
          this.tableData = list
          this.total = Number(count)
        }
        this.loading = false
      })
    },
    handleChangeBillingObject(){
      this.$nextTick(()=>{
        if(this.invoiceForm.billing_object == 2){
          this.invoiceForm.invoice_type = 2
        }
      })
    },
    confirmAuthorization() {
      if(this.invoiceForm.billing_object == 1){
        if(!this.invoiceForm.company_name.trim()){
          return this.$message.error('Please enter Company Name')
        }
        if(!this.invoiceForm.company_tax_id.trim()){
          return this.$message.error('Please enter Tax ID')
        }
      }else{
        if(!this.invoiceForm.name.trim()){
          return this.$message.error('Please enter Name')
        }
      }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.invoiceForm.email) {
        return this.$message.error('Please enter Email')
      } else if (!emailRegex.test(this.invoiceForm.email)) {
        return this.$message.error('Please enter a correct Email')
      }
      let postData = {
        order_id:this.invoiceInfo.id,
        billing_object:this.invoiceForm.billing_object,
        invoice_type:this.invoiceForm.invoice_type,
        email:this.invoiceForm.email,
      }
      if(this.invoiceForm.billing_object == 1){
        postData.company_name = this.invoiceForm.company_name
        postData.company_tax_id = this.invoiceForm.company_tax_id
        postData.company_address = this.invoiceForm.company_address
        postData.phone_number = this.invoiceForm.phone_number
        postData.bank_name = this.invoiceForm.bank_name
        postData.bank_account = this.invoiceForm.bank_account
      }else{
        postData.name = this.invoiceForm.name
      }
      this.btnDisabled = true
      invoiceAdd(postData).then(res =>{
        if(res.code == 200){
          this.pageNum = 1
          this.getOrderList()
          this.showModal = false
          this.$message.success(res.message)
          this.invoiceInfo = JSON.parse(JSON.stringify(this.$options.data().invoiceInfo))
        }
        this.btnDisabled = false
      })
    },
    issueInvoice(row) {
      this.invoiceInfo = row
      this.showModal = true;
    },

  }
}
</script>
<style lang="scss" scoped>
.personal_warp {
  .personal_content {
    padding: 30px;
    margin: 0 auto;
    max-width: 500px;

    .personal_title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      h3 {
        font-size: 24px;
      }

      button {
        border: none;
        padding: 10px 24px;
        background-color: #000;
        color: #fff;
        font-size: 14px;
        border-radius: 8px;
      }
    }

    .personal_info{
      margin-top: 20px;
      .el-pagination{
        text-align: right;
        margin-top: 10px;
      }
    }

  }

}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: rgba(52,53,53,.8);
  border-radius: 10px;
  width: 92%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.modal-header {
  padding: 20px;
  display: flex;
  position: relative;
  h3 {
    margin: 0;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #fff;
    display: block;
    width: 100%;
  }
  .close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #fff;
    padding: 0;
    line-height: 1;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
  }
}

.modal-body {
  padding: 20px 20px;
  max-height: calc(90vh - 140px);
  overflow: auto;
  p {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    font-size: 14px;
    color: #fff;
    &::before {
      content: attr(data-label);
      display: inline-block;
      width: 140px;
      padding-right: 10px;
    }

    input,
    select {
      // 同时为input和select设置相同样式
      flex: 1;
      height: 40px;
      border: 1px solid #fff;
      border-radius: 4px;
      padding: 0 10px;
      background-color: #fff;
      font-size: 14px;
      appearance: none; // 移除默认样式
      background-repeat: no-repeat;
      background-position: right 10px center;
      background-size: 12px;
      color: #000;
    }

    select {
      cursor: pointer;
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");

      option {
        padding: 8px;
      }
      &:focus-visible{
        outline: none;
      }
    }
  }
}

.modal-footer {
  padding: 20px 54px 40px;
  text-align: right;
  .close-btn {
    background-color: #fff;
    border-radius: 20px;
    padding: 10px 30px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
    border: none;
    margin-right: 12px;
    color: #000;
  }
  .confirm-btn {
    background-color: #2a82e4;
    color: white;
    border: none;
    border-radius: 20px;
    padding: 10px 30px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #1a6bc8;
    }
  }
}
</style>
